/**
 * Interface for the Com_Waybills table (Com_Waybills_DTO).
 * Represents complementary data associated with waybills.
 */
export interface ComWaybill {
  /** Unique ID for complementary data */
  waybillComplementaryId?: number;

  /** Reference waybill code */
  waybillComplementaryCode?: string;

  /** Shipment code associated with the waybill */
  waybillComplementaryShipmentCode?: string;

  /** Complementary parameter name */
  waybillComplementaryName?: string;

  /** Category or type of complementary data */
  waybillComplementaryType?: string;

  /** Numeric value of the complementary data */
  waybillComplementaryValueNumber?: number;

  /** Text value of the complementary data */
  waybillComplementaryValueText?: string;

  /** Date value of the complementary data (ISO string, da OffsetDateTime) */
  waybillComplementaryValueDate?: string;

  /** CLOB value of the complementary data */
  waybillComplementaryValueClob?: string;

  /** Status of the complementary data */
  waybillComplementaryStatus?: string;

  /** Creation date of the complementary data (ISO string, da OffsetDateTime) */
  waybillComplementaryCreatedAt?: string;

  /** User that created the complementary data */
  waybillComplementaryCreatedBy?: string;
}

/**
 * Modello di presentazione di un evento bolla (tab Eventi).
 * Varia in base al nome dell'evento (waybillComplementaryName).
 */
export interface WaybillEventPresentation {
  /** Etichetta italiana da mostrare come titolo dell'evento */
  label: string;

  /** Icona FontAwesome (classe fa-*) */
  icon: string;

  /** Variante colore del marker della timeline */
  variant: 'blue' | 'green' | 'purple' | 'orange' | 'red' | 'gray';
}

/**
 * Transcodifica dei nomi evento (waybillComplementaryName) nel relativo
 * modello di presentazione. Gli eventi con nome non mappato usano il
 * fallback (nome grezzo + icona/colore derivati da tipo e stato).
 */
export const WAYBILL_EVENT_PRESENTATIONS: { [name: string]: WaybillEventPresentation } = {
  SENT_TO_PTV: {label: 'Inviato in PTV', icon: 'fa-paper-plane', variant: 'blue'},
  SENT_WAYBILL_TO_CARRIER: {label: 'Bolla inviata al Carrier', icon: 'fa-truck', variant: 'orange'},
  SENT_LOADED_TO_CLIENT: {label: 'LOADED inviata al Cliente', icon: 'fa-file-export', variant: 'green'},
  XML_SENT_TO_FOLDER: {label: 'XML generato per il Cliente', icon: 'fa-file-code', variant: 'purple'},
  POD_SENT_TO_CLIENT: {label: 'POD generata per il Cliente', icon: 'fa-file-signature', variant: 'green'},
  XML_SENT_DELIVERY_TO_FOLDER: {label: 'XML di DELIVERED inviata al Client', icon: 'fa-file-code', variant: 'green'},
  SENT_TRACKING_NUMBER: {label: 'Tracking Number inviato al Dealer', icon: 'fa-barcode', variant: 'blue'},
  VIEWED: {label: 'Visualizzato e Bloccato', icon: 'fa-eye', variant: 'gray'},
  SENT_TO_BMW: {label: 'Bolla inviata a BMW', icon: 'fa-car', variant: 'blue'}
};
